// Action Constants
import { BUDGET_STORE_CONSTANTS } from '../../actionConstants';

// App Constants
import { APPLICATION_CONSTANTS, BUDGET_CONSTANTS, PATHS } from 'AppConstants';

// Saga Utility Functions
import { call, put, takeLatest } from 'redux-saga/effects';

// Redux Actions
import { setApiLoading, setModal } from '../../actions/budgetManagement';

// API call helpers
import { fetchBudgetListApi, fetchBudgetExportApi } from '../../../apis/budgetApis';

// Helper function to handle API response
function* handleApiResponse(response, successAction, failAction, successMessage, failMessage) {
    yield put(setApiLoading({ apiType: BUDGET_STORE_CONSTANTS.LIST_API_LOADING, loading: false }));
    if (response?.status === APPLICATION_CONSTANTS.HAPPAY_API_SUCUCESS_CODE) {
        yield put({
            type: successAction,
            payload: { error: false, message: successMessage || response?.data?.message, data: response.data }
        });
    } else {
        yield put({
            type: failAction,
            payload: { error: true, message: failMessage || response?.data?.message || 'Something went wrong.' }
        });
    }
}

// Saga: Fetch Budget List
function* getBudgetListSaga(action) {
    try {
        yield put(setApiLoading({ apiType: BUDGET_STORE_CONSTANTS.LIST_API_LOADING, loading: true }));
        const response = yield call(fetchBudgetListApi, action.payload);
        yield handleApiResponse(
            response,
            BUDGET_STORE_CONSTANTS.SET_BUDGET_LISTING,
            BUDGET_STORE_CONSTANTS.SET_BUDGET_LISTING,
            'Budget data fetched successfully.',
            'Unable to fetch budget data.'
        );
    } catch (e) {
        yield put({
            type: BUDGET_STORE_CONSTANTS.SET_BUDGET_LISTING,
            payload: { error: true, message: e?.message || 'Something went wrong.' }
        });
        yield put(setApiLoading({ apiType: BUDGET_STORE_CONSTANTS.LIST_API_LOADING, loading: false }));
    }
}

// Saga: Fetch Budget Export
function* getBudgetExportSaga(action) {
    try {
        const response = yield call(fetchBudgetExportApi, action.payload);
        yield handleApiResponse(
            response,
            BUDGET_STORE_CONSTANTS.BUDGET_EXPORT_SUCCESS,
            BUDGET_STORE_CONSTANTS.BUDGET_EXPORT_FAILED,
            'Budget export data fetched successfully.',
            'Unable to fetch budget export data.'
        );
        const successMessage = response?.data?.res_str;
        yield put(setModal({ modalType: BUDGET_CONSTANTS.SUCCESS_MODAL, modalMsg: successMessage }));
    } catch (e) {
        yield put({
            type: BUDGET_STORE_CONSTANTS.BUDGET_EXPORT_FAILED,
            payload: { error: true, message: e?.message || 'Something went wrong.' }
        });
    }
}

export default [
    takeLatest(PATHS.GET_BUDGET_LIST, getBudgetListSaga),
    takeLatest(PATHS.GET_BUDGET_EXPORT, getBudgetExportSaga),
];
